// Catalog of service data used across multiple pages
import {
  LineChart, ReceiptText, Shield, Scale, Briefcase,
  TrendingUp, Users, Home, Car, Heart, FileSignature,
  Building2, Plane, Landmark, PiggyBank, Calculator, FileText,
} from "lucide-react";

export const CORE_SERVICES = [
  {
    slug: "financial",
    icon: LineChart,
    title: "Financial Services",
    description:
      "Personalized financial planning support designed to help individuals, families, and businesses organize goals, plan for the future, and make informed financial decisions.",
    points: [
      "Personal financial planning",
      "Family financial protection",
      "Business financial guidance",
      "Retirement planning support",
      "Investment planning coordination",
      "Long-term growth strategies",
    ],
  },
  {
    slug: "tax",
    icon: ReceiptText,
    title: "Tax Services",
    description:
      "Reliable tax preparation and filing support for individuals and businesses, focused on accuracy, compliance, and year-round planning.",
    points: [
      "Individual tax filing",
      "Business tax filing",
      "Tax planning",
      "IRS notice support coordination",
      "Self-employed tax support",
      "Small business tax guidance",
    ],
  },
  {
    slug: "insurance",
    icon: Shield,
    title: "Insurance Services",
    description:
      "Insurance solutions to help protect what matters most, including personal, family, auto, home, and business coverage needs.",
    points: [
      "Life insurance",
      "Health insurance guidance",
      "Home insurance",
      "Auto insurance",
      "Business insurance",
      "Family protection planning",
    ],
  },
  {
    slug: "legal",
    icon: Scale,
    title: "Legal Services",
    description:
      "Legal service coordination for important personal, family, and business matters through appropriate legal professionals where required.",
    points: [
      "Wills and trusts coordination",
      "Estate planning support",
      "Probate support coordination",
      "Business legal documentation support",
      "Immigration service coordination",
      "Asset protection planning support",
    ],
  },
  {
    slug: "business",
    icon: Briefcase,
    title: "Business Services",
    description:
      "Coordinated support for small business owners and entrepreneurs - tax, insurance, financial planning, and legal documentation under one umbrella.",
    points: [
      "Business tax support",
      "Business insurance guidance",
      "Financial planning for business owners",
      "Legal documentation coordination",
      "Business protection planning",
      "Growth and compliance support coordination",
    ],
  },
];

export const WHO_WE_SERVE = [
  { label: "Individuals", icon: Users },
  { label: "Families", icon: Heart },
  { label: "Small Business Owners", icon: Briefcase },
  { label: "Entrepreneurs", icon: TrendingUp },
  { label: "Professionals", icon: FileText },
  { label: "Immigrants", icon: Plane },
  { label: "Real Estate Owners", icon: Home },
  { label: "Business Investors", icon: Building2 },
  { label: "Retirement Planners", icon: PiggyBank },
  { label: "Community Members", icon: Landmark },
];

export const WHY_CHOOSE = [
  { title: "Transparent Guidance", desc: "Clear communication, no jargon, no surprises." },
  { title: "Comprehensive Service Hub", desc: "One umbrella for finance, tax, insurance and legal." },
  { title: "Long-Term Protection Focus", desc: "Strategies designed for life-long planning." },
  { title: "Personalized Support", desc: "Plans built around your situation, not a template." },
  { title: "USA-Based Service Approach", desc: "American context, regulations, and expectations." },
  { title: "Individual, Family & Business", desc: "Solutions for every life stage and structure." },
  { title: "Trusted Professional Network", desc: "Coordinated access to qualified professionals." },
  { title: "Clear Communication", desc: "Plain English explanations at every step." },
];

export const PROCESS_STEPS = [
  "Schedule a Consultation",
  "Understand Your Goals",
  "Review Your Current Situation",
  "Recommend Service Options",
  "Connect You With the Right Support",
  "Build a Long-Term Protection Plan",
  "Provide Ongoing Guidance",
];

export const BUNDLES = [
  {
    name: "Personal Protection Plan",
    tagline: "For individuals and families",
    color: "navy",
    items: [
      "Tax filing support",
      "Insurance review",
      "Financial planning guidance",
      "Will and estate planning coordination",
      "Family protection consultation",
    ],
  },
  {
    name: "Business Support Plan",
    tagline: "For small businesses and entrepreneurs",
    color: "gold",
    featured: true,
    items: [
      "Business tax support",
      "Business insurance guidance",
      "Financial planning support",
      "Legal documentation coordination",
      "Compliance support coordination",
    ],
  },
  {
    name: "Legacy & Growth Plan",
    tagline: "For families, property owners, long-term planners",
    color: "navy",
    items: [
      "Estate planning coordination",
      "Trust and will support coordination",
      "Asset protection planning",
      "Insurance review",
      "Long-term financial planning support",
    ],
  },
];

export const TESTIMONIALS = [
  {
    role: "Individual Client",
    location: "Texas",
    quote:
      "HSA Service Hub helped me organize my finances, my taxes, and my insurance in one place. The team explained everything clearly without ever rushing me.",
  },
  {
    role: "Family Client",
    location: "Florida",
    quote:
      "We finally have a long-term protection plan that fits our family. From insurance review to estate planning coordination, the entire process felt straightforward and supportive.",
  },
  {
    role: "Small Business Client",
    location: "New York",
    quote:
      "As a small business owner, having one trusted partner for tax filing, business insurance, and legal documentation has been a huge relief. Highly professional team.",
  },
];
